<template>
    <div >

        <div class="TQ_center TQ_margin_4px">


            <div class="TQ_inline TQ_margin_4px" :class="{ 'crossline': !showClues }" @click=clickClues()>
                <div class="TQ_inline TQ_verticalAlignMiddle TQ_margin_2px">
                    {{ass_strings.oneWord_hints[p_system_displayLang_e]}}
                </div>
                <img :src="ass_img_idea_c" id="clueImage" class="TQ_width_20px TQ_verticalAlignMiddle"/>
            </div>

            <div class="TQ_inline TQ_inline TQ_margin_4px" :class="{ 'crossline': !showUnlocks }" @click=clickUnlocks()>
                <div class="TQ_inline TQ_verticalAlignMiddle TQ_margin_2px"> {{ass_strings.oneWord_locks[p_system_displayLang_e]}} </div>
                <img :src="ass_img_unlock" id="unlockImage" class="TQ_verticalAlignMiddle TQ_width_20px"/>
            </div>

            <div class="TQ_inline TQ_margin_4px" :class="{ 'crossline': !showSkips }" @click=clickSkips()>
                <div class="TQ_inline TQ_verticalAlignMiddle TQ_margin_2px"> {{ass_strings.oneWord_skips[p_system_displayLang_e]}} </div>
                <img :src="ass_img_skip_r" id="skipImage" class="TQ_verticalAlignMiddle TQ_width_20px"/>
            </div>

            <div class="TQ_inline TQ_margin_4px" v-if="p_questBody_lastRiddles_ac.length > 0">
                <div class="TQ_inline TQ_verticalAlignMiddle TQ_margin_2px">{{ass_strings.twoWords_lastMissions[p_system_displayLang_e]}}</div>
                <img :src="ass_img_unlock_r" id="lastRiddleImage" class="TQ_verticalAlignMiddle TQ_width_20px"/>
            </div>

        </div>


        <canvas ref="myChart" :height="chartHeight"></canvas>

    </div>
</template>

<script>
    import Chart from '../../../../../node_modules/chart.js';
    import {store_var, store_getStateValue_vo} from "../../../../store";
    import {enum_screenSizesOptions_n} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {format_date_hh_mm_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
    import {validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {helper_finishRiddle_fb, helper_getRiddleWithRiddleId_fc} from "../../../../scripts/S_Helper";
    import {obj_forEach_f} from "../../../../../functions/src/shareCode/Share_S_Obj";
    import {validator_array_fb, validator_objClass_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {
        FB_GameStatus_Team,
        FB_QuestEvent,
        FB_RiddleStatus
    } from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {
        ass_img_idea_c,
        ass_img_skip_g,
        ass_img_skip_w,
        ass_img_unlock,
        ass_img_unlock_r
    } from "../../../../assets/scripts/Ass_Files";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {date_newDate_fd} from "../../../../scripts/S_Date";
    export default {
        name: "C_Creator_Events_Item_Chart",
        props:{
            p_gs_teams_byTeamIdC :{
                type: Object,
                require: true,
                validator(obj){
                    return validator_objClass_fb(obj, FB_GameStatus_Team)
                }
            },
            p_teamStatusRiddles_byTeamId_byRiddleId_c:{
                type: Object,
                require:true,
                validator(obj){
                    return true || validator_objClass_fb(obj, FB_RiddleStatus)
                }
            },
            p_teamStatusLastRiddles_byTeamId_byRiddleId_c:{
                type: Object,
                require:true,
                validator(obj){
                    return true|| validator_objClass_fb(obj, FB_RiddleStatus)
                }
            },
            p_questBody_riddles_ac : {
                type: Array,
                require: true,
                validator(arr){
                    return validator_array_fb(arr)
                }
            },
            p_questBody_lastRiddles_ac : {
                type: Array,
                require: true,
                validator(arr){
                    return validator_array_fb(arr)
                }
            },
            p_questEvent_c:{
                type: FB_QuestEvent,
                require: true,
            },
            p_system_displayLang_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_startingTime_byTeamId_t:{
                type: Object,
                require: true,
            },
            p_durationInMinutes_n:{
                type: Number,
                require: true,
            }

        },
        data(){
            return {
                myChart: null,

                // show
                showClues: true,
                showSkips: true,
                showUnlocks: true,

                // svg
                clueImage: null,
                unlockImage: null,
                skipImage: null,
                lastRiddleImage: null,

                ass_strings  : ass_strings,
                ass_img_idea_c  : ass_img_idea_c,
                ass_img_unlock  : ass_img_unlock,
                ass_img_unlock_r : ass_img_unlock_r,
                ass_img_skip_r : ass_img_skip_g,
            }
        },
        computed:{
            chartHeight(){
                return store_getStateValue_vo(store_var.system_windowSizeType_e).val === enum_screenSizesOptions_n.mobile ? 300 : 80
            },

            co_getNumbersOfLocks_n(){
                let ans = 0;
                this.p_questBody_riddles_ac.forEach((qb_riddle_c) => {
                    ans += qb_riddle_c.qbr_locks_ac.length
                })
                this.p_questBody_lastRiddles_ac.forEach((qb_riddle_c) => {
                    ans += qb_riddle_c.qbr_locks_ac.length
                })


                return ans
            },

        },
        methods:{
            setChartData(){

                // 1) cleanChartData
                this.cleanChartData()

                // 2) add datasets for each team
                for(let teamId_uid in this.p_gs_teams_byTeamIdC){

                    // 2.1) set dataset
                    let dataset = {
                        label: this.p_gs_teams_byTeamIdC[teamId_uid].gst_name_s,
                        fill: false,

                        backgroundColor: this.p_gs_teams_byTeamIdC[teamId_uid].gst_color_s,
                        pointBackgroundColor: this.p_gs_teams_byTeamIdC[teamId_uid].gst_color_s,
                        borderColor: this.p_gs_teams_byTeamIdC[teamId_uid].gst_color_s,
                        data : [],
                    }

                    // 2.2) add points
                    this.addChartPoints(teamId_uid, dataset)

                    // 2.3) sort dataset by date
                    dataset.data.sort((a,b) => {
                        return a.x - b.x
                    })

                    // 2.4) setPointsFinishRiddleNum
                    this.setPointsFinishRiddleNum(dataset, teamId_uid)

                    // 2.5) setPointsStyle
                    this.setPointsStyle(dataset)

                    // 2.6) add dataset
                    this.myChart.data.datasets.push(dataset)

                }

                this.myChart.update()

                // 3) refresh chart
            },

            cleanChartData(){
                // empty data
                while(this.myChart.data.datasets.length > 0){
                    this.myChart.data.datasets.pop()
                }
            },
            addChartPoints(teamId_uid, dataset){

                // add starting game point
                let xy = {
                    y : '',
                    x: this.p_startingTime_byTeamId_t[teamId_uid],
                    riddleId: -1,
                    riddleTitle: ass_strings.twoWords_startQuest[this.p_system_displayLang_e],
                    pointStyle: 'circle',
                }
                dataset.data.push(xy)

                // add riddle status
                for(let riddleId in this.p_teamStatusRiddles_byTeamId_byRiddleId_c[teamId_uid]) {

                    let riddleStatus_c = this.p_teamStatusRiddles_byTeamId_byRiddleId_c[teamId_uid][riddleId]
                    let riddleData_c = helper_getRiddleWithRiddleId_fc(this.p_questBody_riddles_ac, riddleId)


                    this.addChartPoints_addPoint(riddleStatus_c, riddleData_c,  riddleId, dataset, this.unlockImage)
                }

                // add last riddle status
                for(let riddleId in this.p_teamStatusLastRiddles_byTeamId_byRiddleId_c[teamId_uid]) {

                    let riddleStatus_c = this.p_teamStatusLastRiddles_byTeamId_byRiddleId_c[teamId_uid][riddleId]

                    let riddleData_c = helper_getRiddleWithRiddleId_fc(this.p_questBody_lastRiddles_ac, riddleId)



                    this.addChartPoints_addPoint(riddleStatus_c, riddleData_c, riddleId, dataset, this.lastRiddleImage)
                }
            },
            addChartPoints_addPoint(riddleStatus_c, qb_riddle_c, riddleId_n, dataset_ao, unlockPointIcon_s){

                if(qb_riddle_c == null){
                    return
                }

                let riddleTitle_s = qb_riddle_c.qbr_title_blc_s[this.p_system_displayLang_e]

                // for each lock
                obj_forEach_f(riddleStatus_c.rs_unlock_byLockId_c, (rs_unlock_c, lockIndex_n) => {

                    let lockTitle_s = qb_riddle_c.qbr_locks_ac[lockIndex_n].qbrl_title_blc_s[this.p_system_displayLang_e]

                    // 1.1) add skips to dataset
                    if(this.showSkips && rs_unlock_c.rsud_skip_b){
                        let xy = {
                            y : '',
                            riddleId: riddleId_n,
                            x : rs_unlock_c.rsud_timestemp_t,
                            pointStyle : this.skipImage,
                            riddleTitle : riddleTitle_s + " | " + lockTitle_s,
                            finishRiddle: true
                        }
                        dataset_ao.data.push(xy)
                    }

                    // 1.2) add unlocks to dataset
                    else if(this.showUnlocks && helper_finishRiddle_fb(qb_riddle_c, riddleStatus_c)){

                        let xy = {
                            y : '',
                            riddleId: riddleId_n,
                            x : rs_unlock_c.rsud_timestemp_t,
                            pointStyle : unlockPointIcon_s,
                            riddleTitle : riddleTitle_s + " | " + lockTitle_s,
                            finishRiddle: true
                        }
                        dataset_ao.data.push(xy)
                    }
                })

                // 1.3) add clues to dataset
                if(riddleStatus_c.rs_clues_byClueId_c && this.showClues){

                    for(let cluesId_n in riddleStatus_c.rs_clues_byClueId_c){


                        let clueTitle_s = qb_riddle_c.qbr_clues_ac[cluesId_n].qbrc_title_blc_s[this.p_system_displayLang_e]

                        let xy = {
                            y : '',
                            riddleId: riddleId_n,
                            x : riddleStatus_c.rs_clues_byClueId_c[cluesId_n].rsua_timestamp_t,
                            pointStyle : this.clueImage,
                            riddleTitle : riddleTitle_s + " | " + clueTitle_s
                        }

                        dataset_ao.data.push(xy)
                    }
                }



            },

            setPointsFinishRiddleNum(dataset, teamId){


                // add Yaxes (finish riddles)
                let finishRiddles = 0;
                dataset.data.forEach(xy => {

                    if(xy.finishRiddle){
                        finishRiddles++
                    }

                    xy.y = finishRiddles

                })

            },
            setPointsStyle(dataset){

                // point style
                let pointStyle = []
                dataset.data.forEach(xy => {
                    pointStyle.push(xy.pointStyle)
                })

                dataset.pointStyle = pointStyle

            },

            clickClues(){
                this.showClues = !this.showClues;
                this.setChartData()
            },
            clickUnlocks(){
                this.showUnlocks = !this.showUnlocks;
                this.setChartData()
            },
            clickSkips(){
                this.showSkips = !this.showSkips;
                this.setChartData()
            }

        },
        watch: {
            p_teamStatusRiddles_byTeamId_byRiddleId_c:{
                handler: function(val, oldVal) {
                    this.setChartData()
                },
                deep: true
            } ,
            p_teamStatusLastRiddles_byTeamId_byRiddleId_c:{
                handler: function(val, oldVal) {
                    this.setChartData()
                },
                deep: true
            },
            p_gs_teams_byTeamIdC : {
                handler: function(val, oldVal) {
                    this.setChartData()
                },
                deep: true
            }
        },

        mounted() {

            this.myChart = new Chart(this.$refs.myChart, {
                type: 'line',
                data : {
                    datasets: []
                },
                options:
                    {
                        scales: {
                            xAxes: [{
                                type: 'time',
                            }],
                            yAxes: [{
                                scaleLabel: {
                                    display: true,
                                    labelString: ass_strings.oneWord_locks[this.p_system_displayLang_e]
                                },
                                ticks: {
                                    min: 0,
                                    max: this.co_getNumbersOfLocks_n
                                }
                            }]
                        },
                        legend: {
                            display: true,
                            position: 'bottom',
                            labels: {
                                fontSize: 20,
                                // boxWidth: 2,
                            }
                        },
                        tooltips: {
                            titleFontSize: 14,
                            titleMarginBottom: 8,
                            callbacks: {
                                title: function(tooltipItems, data) {
                                    //Return value for title
                                    // return 'Time: ' + formatDate_hour(date_newDate_fd(tooltipItems[0].xLabel).getTime())

                                    return  data.datasets[tooltipItems[0].datasetIndex].data[tooltipItems[0].index].riddleTitle
                                },
                                label: function(tooltipItem, data) {
                                    // return data.datasets[tooltipItem.datasetIndex].label || '';
                                    return format_date_hh_mm_fs(date_newDate_fd(tooltipItem.xLabel).getTime());
                                },

                            }
                        }
                    }
            });
            this.clueImage = document.getElementById('clueImage')
            this.unlockImage = document.getElementById('unlockImage')
            this.skipImage = document.getElementById('skipImage')
            this.lastRiddleImage = document.getElementById('lastRiddleImage')


            this.setChartData()


        },


    }
</script>

<style scoped>


</style>